import React from "react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading text-xl md:text-2xl font-bold text-navy mb-3">{title}</h2>
    <div className="text-sm text-foreground/80 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page">
      <section className="bg-navy text-white section-pad">
        <div className="container-x">
          <span className="accent-bar mb-4" />
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight">Disclaimer</h1>
          <p className="text-white/70 mt-3 text-sm">Last updated: February 2026</p>
        </div>
      </section>
      <section className="container-x section-pad max-w-4xl">
        <Section title="1. Not a Lender">
          <p>Crew Connect FinInvesto is a financial consultancy that connects businesses with banks, NBFCs, and private financiers. We are NOT a bank, NBFC, or registered lender. We do not directly lend, sanction, or disburse loans.</p>
        </Section>
        <Section title="2. No Guarantee of Approval">
          <p>All loan products mentioned on this website are offered by our partner lenders, who retain full discretion over approval, terms, interest rates, and disbursement timelines. We make no warranty regarding the outcome of any loan application.</p>
        </Section>
        <Section title="3. Not Financial Advice">
          <p>Information presented on this website is for general informational and educational purposes only and does not constitute financial, legal, or investment advice. You should consult qualified professionals before making any financial decisions.</p>
        </Section>
        <Section title="4. Indicative Figures">
          <p>Ticket sizes, eligibility criteria, and timelines mentioned are indicative based on prevailing partner-lender norms and are subject to change without notice.</p>
        </Section>
        <Section title="5. No Upfront Fees Promise">
          <p>We do not collect any upfront processing fees from clients before service engagement. Beware of fraudsters claiming to represent us — always verify by calling +91 84478 67463 or emailing support@crewconnectfininvesto.com.</p>
        </Section>
        <Section title="6. External Content">
          <p>This website may include third-party content and links. We are not responsible for the accuracy or availability of such content.</p>
        </Section>
        <Section title="7. Limitation of Liability">
          <p>To the maximum extent permitted by law, Crew Connect FinInvesto shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website or our services.</p>
        </Section>
      </section>
    </div>
  );
}
